export default "__VITE_ASSET__50515b29__"